import api from '../utils/api';

const examsService = {
  listSessions: async (params) => api.get('/api/exams/sessions', { params }),
  createSession: async (data) => api.post('/api/exams/sessions', data),
  getSession: async (id) => api.get(`/api/exams/sessions/${id}`),
  updateSession: async (id, data) => api.put(`/api/exams/sessions/${id}`, data),
  deleteSession: async (id) => api.delete(`/api/exams/sessions/${id}`),

  createSchedule: async (sessionId, data) => api.post(`/api/exams/sessions/${sessionId}/schedules`, data),
  updateSchedule: async (id, data) => api.put(`/api/exams/schedules/${id}`, data),
  deleteSchedule: async (id) => api.delete(`/api/exams/schedules/${id}`),

  generateSeating: async (scheduleId) => api.post(`/api/exams/schedules/${scheduleId}/generate-seating`),
  getSeating: async (scheduleId) => api.get(`/api/exams/schedules/${scheduleId}/seating`),
  updateSeat: async (seatId, data) => api.put(`/api/exams/seating/${seatId}`, data),

  assignInvigilator: async (scheduleId, data) => api.post(`/api/exams/schedules/${scheduleId}/invigilators`, data),
  listInvigilators: async (scheduleId) => api.get(`/api/exams/schedules/${scheduleId}/invigilators`),
  removeInvigilator: async (id) => api.delete(`/api/exams/invigilators/${id}`),

  // Result publication controls
  setReleaseDate: async (sessionId, data) => api.put(`/api/exams/sessions/${sessionId}/release-date`, data),
  publishResults: async (sessionId) => api.post(`/api/exams/sessions/${sessionId}/publish-results`),
  unpublishResults: async (sessionId) => api.post(`/api/exams/sessions/${sessionId}/unpublish-results`),
};

export default examsService;
